---
de:
  errors:
    messages:
      after: muss nach %{restriction} liegen
      before: muss vor %{restriction} liegen
      invalid_date: ist kein gültiges Datum
      invalid_datetime: ist kein gültiges Datum/Uhrzeit
      invalid_time: ist keine gültige Uhrzeit
      is_at: muss gleich %{restriction} sein
      on_or_after: muss am oder nach %{restriction} liegen
      on_or_before: muss am oder vor %{restriction} liegen
